<template v-slot="main">
  <div class="modal-container">
    <div class="modal-body">
      <p style="color: red">
      <!-- TODO: add errors to i18n.js -->
      {{ $t(`error.${errMsg}`) }}
      </p>
    </div>

    <div class="modal-footer">
      <button v-on:click="closeModal" class="btn">
        {{ $t('OK') }}
      </button>
    </div>
  </div>
</template>

<script>
import BaseModal from '@/layout/modals/BaseModal.vue'

export default {
  extends: BaseModal,
  name: 'ErrorMsgModal',
  computed: {
    errMsg () {
      const regex = /\s/gmi
      const msg = this.$store.state.global.errorMsg
      if (msg === null) {
        return 'Oups'
      }
      return msg.replace(regex, '_')
    }
  }
}
</script>
